export * from "src/generated/hooks/form-service/requests/types.gen";
export type {
  V2_AddressQuestion as AddressQuestion,
  V2_AddressQuestionWithoutId as AddressQuestionWithoutId,
  V2_BaseOption as BaseOption,
  V2_BaseQuestion as BaseQuestion,
  V2_CustomQuestion as CustomQuestion,
  V2_CustomQuestionWithoutId as CustomQuestionWithoutId,
  V2_DateQuestion as DateQuestion,
  V2_DateQuestionWithoutId as DateQuestionWithoutId,
  V2_DisclaimerSection as DisclaimerSection,
  V2_EmailQuestion as EmailQuestion,
  V2_EmailQuestionWithoutId as EmailQuestionWithoutId,
  V2_FamilyEditableStatusType as FamilyEditableStatusType,
  V2_FileUploadQuestion as FileUploadQuestion,
  V2_FileUploadQuestionWithoutId as FileUploadQuestionWithoutId,
  V2_FormSectionBase as FormSectionBase,
  V2_FormTemplate as FormTemplate,
  V2_FormTemplateWithoutId as FormTemplateWithoutId,
  V2_FreeTextQuestion as FreeTextQuestion,
  V2_FreeTextQuestionWithoutId as FreeTextQuestionWithoutId,
  V2_GeneralSection as GeneralSection,
  V2_GenericSections as GenericSections,
  V2_GradesQuestion as GradesQuestion,
  V2_GradesQuestionWithoutId as GradesQuestionWithoutId,
  V2_MultiSelectQuestion as MultiSelectQuestion,
  V2_MultiSelectQuestionWithoutId as MultiSelectQuestionWithoutId,
  V2_NumberQuestion as NumberQuestion,
  V2_NumberWithoutId as NumberWithoutId,
  V2_Option as Option,
  V2_OptionWithoutId as OptionWithoutId,
  V2_PermissionLevel as PermissionLevel,
  V2_PhoneNumberQuestion as PhoneNumberQuestion,
  V2_PhoneNumberQuestionWithoutId as PhoneNumberQuestionWithoutId,
  V2_PreRankingSection as PreRankingSection,
  V2_Question as Question,
  V2_QuestionType as QuestionType,
  V2_QuestionWithoutId as QuestionWithoutId,
  V2_SchoolRankingSection as SchoolRankingSection,
  V2_Section as Section,
  V2_SectionType as SectionType,
  V2_SectionWithoutId as SectionWithoutId,
  V2_SingleSelectQuestion as SingleSelectQuestion,
  V2_SingleSelectQuestionWithoutId as SingleSelectQuestionWithoutId,
} from "src/generated/hooks/form-service/requests/types.gen";

export const SectionTypes = {
  PreRankingSection: "PreRankingSection",
  SchoolRankingSection: "SchoolRankingSection",
  DisclaimerSection: "DisclaimerSection",
  GeneralSection: "GeneralSection",
} as const;

export const SectionTypeList = [
  SectionTypes.PreRankingSection,
  SectionTypes.SchoolRankingSection,
  SectionTypes.GeneralSection,
  SectionTypes.DisclaimerSection,
] as const;

export const QuestionTypes = {
  SingleSelect: "SingleSelect",
  MultiSelect: "MultiSelect",
  FreeText: "FreeText",
  FileUpload: "FileUpload",
  Grades: "Grades",
  Email: "Email",
  PhoneNumber: "PhoneNumber",
  Address: "Address",
  CustomQuestion: "CustomQuestion",
  Date: "Date",
  Number: "Number",
} as const;

export const QuestionTypeList = [
  QuestionTypes.SingleSelect,
  QuestionTypes.MultiSelect,
  QuestionTypes.FreeText,
  QuestionTypes.FileUpload,
  QuestionTypes.Grades,
  QuestionTypes.Email,
  QuestionTypes.PhoneNumber,
  QuestionTypes.Address,
  QuestionTypes.CustomQuestion,
  QuestionTypes.Date,
  QuestionTypes.Number,
] as const;
